import { Dao, Element, ContentOverlay, Button, Option, Toast } from '@chaysehartsuff/active-html';
import { Table } from '@chaysehartsuff/active-html';
import { FieldType } from '@chaysehartsuff/active-html';
import {FormatType} from '@chaysehartsuff/active-html';
import User from '../../models/User.js';

export default class UserList extends Element {

    constructor(tableId, createUserBtnId){
        super();

        this.inviteBtn = Element.createInstanceFromId(createUserBtnId);
        this.inviteBtn.onEvent('click', this.onInviteUser.bind(this));

        this.table = new Table(tableId, new User(), [
            {
                label:"ID",
                name: "id",
                sortable: true,
                searchable: false,
                visible: false,
                editable: false,
                type: FieldType.NUMBER
            },
            {
                label: "Role Level",
                name: "role_level",
                sortable: false,
                searchable: false,
                visible: false,
                use_in_default_search: false,
                type: FieldType.STRING
            },
            {
                label:"Name",
                name: "name",
                sortable: true,
                searchable: true,
                type: FieldType.STRING
            },
            {
                label:"Email",
                name: "email",
                sortable: false,
                searchable: true,
                type: FieldType.STRING
            },
            {
                label: "Role",
                name: "role",
                sortable: true,
                searchable: true,
                use_in_default_search: false,
                type: FieldType.STRING
            },
            {
                label:"Verified",
                name: "verified",
                sortable: true,
                searchable: true,
                use_in_default_search: false,
                type: FieldType.BOOLEAN
            },
            {
                label:"Token",
                name: "verify_token",
                visible: false,
                use_in_default_search: false,
                type: FieldType.STRING
            }
        ], {
            [FieldType.DATE]: FormatType.DATE.FULL_TEXT
        });
        this.table.addRowAction('edit', 'Edit', this.onRowEdit.bind(this));
        this.table.addRowAction('delete', 'Delete', this.onRowDelete.bind(this));
        this.bindToDom();
    }

    onInviteUser() {
        let roleInput = new Element('select')
            .addClass('mb-4 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200');

        Dao.modelRequest('getRoles', new User(), (response) => {
            const roles = response.roles || {};
            Object.keys(roles).forEach((roleKey) => {
                const role = roles[roleKey] || {};
                roleInput.addContent(
                    new Option(roleKey, role.name)
                );
            });
        });

        const emailInput = new Element('input')
            .setAttribute('type', 'email')
            .setAttribute('placeholder', 'name@example.com')
            .addClass('mb-4 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200');

        let overlay = new ContentOverlay(
            new Element()
                .addClass('w-full max-w-md rounded-2xl bg-white p-6 shadow-xl ring-1 ring-slate-200')
                .addContent(
                    new Element('h2')
                        .addClass('mb-4 block text-lg font-semibold leading-tight text-slate-900')
                        .addContent('Invite User')
                        .addContent(
                            new Element('label')
                                .addClass('mb-1 mt-4 block text-sm font-medium text-slate-700')
                                .addContent('Email')
                        )
                        .addContent(
                            emailInput
                        )
                )
                .addContent(
                    new Element('label')
                        .addClass('mb-1 mt-4 block text-sm font-medium text-slate-700')
                        .addContent('Role')
                )
                .addContent(
                    roleInput
                )
                .addContent(
                    new Element().addClass('flex justify-end gap-2 border-t border-slate-200 pt-4')
                        .addContent(
                            new Element('button')
                                .setAttribute('type', 'button')
                                .addClass('inline-flex items-center justify-center rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-200')
                                .addContent('Cancel')
                                .onEvent('click', () => {
                                    this.removeContent('invite-user-overlay');
                                })
                        )
                        .addContent(
                            new Element('button')
                                .setAttribute('type', 'button')
                                .addClass('inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300')
                                .addContent('Invite')
                                .onEvent('click', () => {
                                    let user = new User();
                                    user.email = emailInput.getValue();
                                    user.role_level = roleInput.getValue();
                                    user.createSync();

                                    this.removeContent('invite-user-overlay');
                                    this.table.fetchRows();
                                    new Toast(`Email sent to "${user.email}"`).success();
                                })
                        )
                )
        );

        this.addContent(overlay, 'invite-user-overlay');
    }

    onRowEdit(row) {

        let roleInput = new Element('select')
            .addClass('mb-4 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200');
        Dao.modelRequest('getRoles', new User(), (response) => {
            const roles = response.roles || {};
            Object.keys(roles).forEach((roleKey) => {
                const role = roles[roleKey] || {};
                roleInput.addContent(
                    new Option(roleKey, role.name)
                        .selected(parseInt(roleKey) === parseInt(row.role_level))
                );
            });
        });

        const nameInput = new Element('input')
            .setAttribute('type', 'text')
            .setAttribute('value', row.name)
            .addClass('mb-4 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200');
        let overlay = new ContentOverlay(
            new Element()
                .addClass('w-full max-w-md rounded-2xl bg-white p-6 shadow-xl ring-1 ring-slate-200')
                .addContent(
                    new Element('h2')
                        .addClass('mb-4 block text-lg font-semibold leading-tight text-slate-900')
                        .addContent(`Edit User`)
                        .addContent(
                            new Element('label')
                                .addClass('mb-1 mt-4 block text-sm font-medium text-slate-700')
                                .addContent('Name')
                        )
                        .addContent(
                            nameInput
                        )
                )
                .addContent(
                    new Element('label')
                        .addClass('mb-1 mt-4 block text-sm font-medium text-slate-700')
                        .addContent('Role')
                )
                .addContent(
                    roleInput
                )
                .addContent(
                    new Element().addClass('flex justify-end gap-2 border-t border-slate-200 pt-4')
                        .addContent(
                            new Element('button')
                                .setAttribute('type', 'button')
                                .addClass('inline-flex items-center justify-center rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-200')
                                .addContent('Cancel')
                                .onEvent('click', () => {
                                    this.removeContent('edit-category-overlay');
                                })
                        )
                        .addContent(
                            new Element('button')
                                .setAttribute('type', 'button')
                                .addClass('inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300')
                                .addContent('Save')
                                .onEvent('click', () => {
                                    let user = new User();
                                    user.id = row.id;
                                    user.getSync();

                                    user.name = nameInput.getValue();
                                    user.role_level = roleInput.getValue();
                                    user.update({}, function(response){
                                        const errors = response?.errors;
                                        const firstErrorGroup = Array.isArray(errors) ? errors[0] : Object.values(errors || {})[0];
                                        const firstErrorMessage = Array.isArray(firstErrorGroup) ? firstErrorGroup[0] : firstErrorGroup;

                                        if(firstErrorMessage){
                                            new Toast('Error updating user: ' + firstErrorMessage).error();
                                        } else {
                                            new Toast('User updated successfully').success();
                                        }
                                    });
                                    this.removeContent('edit-category-overlay');
                                    this.table.fetchRows();
                                })
                        )
                )
        );
        this.addContent(overlay, 'edit-category-overlay');
    }

    onRowDelete(row) {
        let overlay = new ContentOverlay(
            new Element()
                .addClass('w-full max-w-xl rounded-xl bg-white p-10 shadow-2xl')
                .addContent(
                    new Element('h2')
                        .addClass('mb-5 text-lg font-semibold text-slate-900')
                        .addContent('Delete User')
                )
                .addContent(
                    new Element('p')
                        .addClass('mb-5 text-sm text-slate-600')
                        .addContent(`Are you sure you want to delete the user "${row.name}"? This action cannot be undone.`)
                )
                .addContent(
                    new Element().addClass('flex justify-around items-center')
                        .addContent(
                            new Element('button')
                                .setAttribute('type', 'button')
                                .addClass('rounded-lg bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-200')
                                .addContent('Cancel')
                                .onEvent('click', () => {
                                    this.removeContent('edit-category-overlay');
                                })
                        )
                        .addContent(
                            new Element('button')
                                .setAttribute('type', 'button')
                                .addClass('rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-700')
                                .addContent('Delete')
                                .onEvent('click', () => {
                                    let user = new User(false);
                                    user.id = row.id;
                                    user.getSync();

                                    user.delete({}, function(response){
                                        this.removeContent('edit-category-overlay');
                                        this.table.fetchRows();

                                        const errors = response?.errors;
                                        const firstErrorGroup = Array.isArray(errors) ? errors[0] : Object.values(errors || {})[0];
                                        const firstErrorMessage = Array.isArray(firstErrorGroup) ? firstErrorGroup[0] : firstErrorGroup;

                                        if(firstErrorMessage){
                                            new Toast('Error deleting user: ' + firstErrorMessage).error();
                                        } else {
                                            new Toast('User deleted successfully').success();
                                        }
                                    }.bind(this));

                                })
                        )
                )
        );
        this.addContent(overlay, 'edit-category-overlay');
    }
}